import { type ReactNode } from "react";
import {
  DevAuthWrapper as SharedDevAuthWrapper,
  type TokenExchangeState,
} from "@legal-500/auth-client";
import LoadingState from "../LoadingState";
import EmptyState from "../EmptyState";
import { removeBootLoader } from "../../utils/bootLoader";
import { publicRuntimeConfig } from "../../config/publicRuntimeConfig";

const DEV_USER_EMAIL = publicRuntimeConfig.devUserEmail;
const apiBaseUrl = publicRuntimeConfig.apiBaseUrl;

function buildExchangeBody(email: string): Record<string, unknown> {
  return { devMode: true, email };
}

function handleStateChange(state: TokenExchangeState): void {
  removeBootLoader();
}

function renderLoading(): ReactNode {
  return <LoadingState fullscreen message={`Authenticating as ${DEV_USER_EMAIL}...`} />;
}

function renderError(error: Error, retry: () => void): ReactNode {
  return (
    <EmptyState
      variant="error"
      title="Dev authentication failed"
      message={`Failed to obtain dev token: ${error.message}`}
      action={{ label: "Retry", onClick: retry }}
    />
  );
}

export default function DevAuthWrapper({ children }: { children: ReactNode }) {
  return (
    <SharedDevAuthWrapper
      tokenExchangeUrl={`${apiBaseUrl}/token`}
      buildExchangeBody={buildExchangeBody}
      email={DEV_USER_EMAIL}
      onStateChange={handleStateChange}
      renderLoading={renderLoading}
      renderError={renderError}
    >
      {children}
    </SharedDevAuthWrapper>
  );
}
